import { render, staticRenderFns } from "./_storeCartGoodsItem.vue?vue&type=template&id=4b67c1c1&"
import script from "./_storeCartGoodsItem.vue?vue&type=script&lang=js&"
export * from "./_storeCartGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./_storeCartGoodsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports